import { createSelector } from '@reduxjs/toolkit';

import instanceOfRange from '@/utils/instanceOfRange';

import filtersDataSelector from './data';

/**
 * Возвращает флаг, который указывает на отсутствует данных по фильтрам
 */
const isFiltersDataMissingSelector = createSelector(filtersDataSelector, filtersData => {
  if (!filtersData.isSuccess) {
    return false;
  }
  const { data: filterRawData } = filtersData.data;
  if (!filterRawData || !Object.keys(filterRawData).length) {
    return true;
  }
  return Object.values(filterRawData).every(values => {
    if (instanceOfRange(values)) {
      return !values.length || values.every(value => value <= 0);
    }
    return !values.length;
  });
});

export default isFiltersDataMissingSelector;
